<template>
  <div id="manageClass">
    <div class="allBodyDiv">
      <div style="margin-top: 15px; display: none">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manageclass' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/testlist' }"
            >考试列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <el-row class="manageClassBody" :gutter="20">
        <el-col :span="24" class="leftMember">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <i class="blueI" style="left: 10px"></i>

              <div style="display: inline-block">
                <span class="cardHeader">{{ $route.query.name }}</span>
                <span style="font-size: 12px; color: #7d7d7d"
                  >({{ $route.query.title }})</span
                >
              </div>
              <div class="fr">
                完成情况：{{ pageDaa.sub_num }}/{{ pageDaa.student_num }}
              </div>
              <div class="fr" style="margin-right: 31%">
                <el-radio-group
                  v-model="radio3"
                  @change="
                    getData();
                    first();
                  "
                >
                  <el-radio-button :label="1">综合统计</el-radio-button>
                  <el-radio-button :label="2">按人统计</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div style="margin-top: 30px">
              <div style="position: relative">
                <div>
                  <div v-if="radio3 == 1">
                    <div style="position: absolute">
                      <span
                        ><img
                          src="/static/images/exam/quxian.png"
                          alt=""
                          align="top"
                      /></span>
                      分数分布
                    </div>
                    <ve-histogram
                      @blur="console.log(123123)"
                      id="canvas"
                      :data="chartData"
                      :settings="chartSettings"
                    ></ve-histogram>
                  </div>

                  <div v-else style="margin-bottom: 20px">
                    <div>
                      <el-row
                        style="
                          padding-bottom: 10px;
                          border-bottom: 1px solid #ebedf3;
                        "
                      >
                        <div
                          v-for="i in listData"
                          :key="i.userId"
                          :class="{ testCard: true, activeTest: i.active }"
                          style="margin-bottom: 20px"
                          @click="
                            getData(i.userId);
                            getStudentExamInfo(i.exerciseId, i.userId);
                          "
                        >
                          <div class="ellipsis" style="height: 25px;">{{ i.markName || i.studentName }}</div>
                          <span>{{ i.score ? i.score : "暂无得" }}分</span>
                          <span>{{ i.ranking ? i.ranking : "暂无排" }}名</span>
                        </div>
                      </el-row>
                    </div>

                    <el-row style="margin-top: 35px">
                      <div
                        style="
                          height: 25px;
                          line-height: 16px;
                          margin-bottom: 15px;
                        "
                      >
                        <span
                          ><img
                            src="/static/images/exam/dianpin.png"
                            alt=""
                            align="top"
                        /></span>
                        实验点评
                      </div>
                      <div class="testDetails">
                        <div
                          v-if="
                            data.commentsList && data.commentsList.length > 0
                          "
                          style="color: #f76252"
                        >
                          在操作顺序方面，需要注意以下几点
                        </div>

                        <div
                          v-for="(index, i) in data.commentsList"
                          style="padding-left: 10px"
                        >
                          {{ i + 1 }}.&nbsp;{{ index }}
                        </div>

                        <div
                          v-if="stepData && stepData.length > 0"
                          style="color: #f76252"
                        >
                          在操作及数据处理上，需要注意以下几点
                        </div>
                        <div
                          v-for="(index, i) in stepData"
                          style="padding-left: 10px"
                        >
                          {{ i + 1 }}.&nbsp;{{ index }}
                        </div>
                      </div>
                    </el-row>
                  </div>
                </div>

                <div
                  style="height: 25px; line-height: 25px; margin-bottom: 15px"
                >
                  <span
                    ><img
                      src="/static/images/exam/defen.png"
                      alt=""
                      align="top"
                  /></span>
                  得分细则
                </div>

                <div v-if="radio3 == 1">
                  <div class="tableDataHeader">
                    <div style="width: 439px">实验步骤</div>
                    <div style="width: 437px">实验操作</div>
                    <div style="width: 279px">错误人数</div>
                  </div>
                  <div class="scoreRuleTable">
                    <div v-for="i in data" :key="i.id">
                      <div class="dataTitle">{{ i.step_name }}</div>
                      <div class="dataList">
                        <div
                          class="dataBody"
                          v-for="a in i.itemStep"
                          :key="a.id"
                        >
                          <div class="stepName">{{ a.step_name }}</div>
                          <div
                            class="errorNum"
                            :style="{ color: a.error_id <= 0 ? '' : 'red' }"
                          >
                            <span
                              style="cursor: pointer"
                              @click="errorNums(a)"
                            >
                              {{ a.error_nums }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div class="tableDataHeader">
                    <div style="width: 439px">实验步骤</div>
                    <div style="width: 437px">实验操作</div>
                    <div style="width: 119px">评分</div>
                    <div style="width: 159px; border-right: none">错误类型</div>
                  </div>
                  <div class="tableDataBody">
                    <div v-for="i in data.stepList">
                      <div>
                        <div
                          :style="{
                            width: '439px',
                            height: i.nameHeight + 'px',
                            lineHeight: i.nameHeight + 'px',
                            overflow: 'hidden',
                          }"
                          class="dataTitle"
                        >
                          {{ i.step_name }}
                        </div>
                        <div class="dataBody" v-for="a in i.itemStep">
                          <div
                            :style="{
                              width: '437px',
                              height: a.stepHeight + 'px',
                              lineHeight: a.stepHeight + 'px',
                              overflow: 'hidden',
                            }"
                          >
                            {{ a.step_name }}
                          </div>
                          <div
                            :style="{
                              width: '119px',
                              height: a.stepHeight + 'px',
                              lineHeight: a.stepHeight + 'px',
                              overflow: 'hidden',
                              color: a.score <= 6 && a.score ? 'red' : '',
                            }"
                          >
                            {{ a.score ? a.score : "暂无评分" }}
                          </div>
                          <div class="errorInfo">
                            <div style="width: 140px; text-align: center">
                              <span v-if="a.error != '正确'">
                                <img
                                  v-if="a.error.indexOf('数据') != -1"
                                  src="/static/images/exam/data.png"
                                  width="14px"
                                  alt=""
                                />
                                <img
                                  v-else-if="a.error.indexOf('操作') != -1"
                                  src="/static/images/exam/operate.png"
                                  width="14px"
                                  alt=""
                                />
                                <img
                                  v-else-if="a.error.indexOf('顺序') != -1"
                                  src="/static/images/exam/order.png"
                                  width="14px"
                                  alt=""
                                />
                                <span v-else></span>
                              </span>
                              <span v-else></span>
                              {{ a.error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="错误人数"
      :visible.sync="errorNumsDaingl"
      custom-class="nbDialog"
      width="500px"
    >
      <div style="overflow: auto; max-height: 400px">
        <div
          @click="switchRadio(i.userId, i.exercise_id)"
          v-for="i in errroeNumdata.user_list"
          style="float: left; margin: 0 10px; cursor: pointer"
        >
          <img
            src="/static/img/account/usericon.png"
            width="25px"
            style="border-radius: 50%"
            alt=""
          /><br />
          <span>{{ i.nickname }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getusertestexamcount,
  gettestrecord,
  getclassexaminfo,
  getuserexamcount,
  getstudentexaminfo,
  getstudentexaminfo1,
} from "./../../api/exam_api";
import ElButton from "../../../../../node_modules/element-ui/packages/button/src/button";
export default {
  components: { ElButton },
  data() {
    return {
      errroeNumdata: {},
      errorNumsDaingl: false,
      pageDaa: "",
      visible2: false,
      tableData2: [],
      currentPage4: 1,
      radio3: 1,
      chartData: {
        columns: ["counttime", "countnum"],
        rows: [],
      },
      chartSettings: {
        labelMap: {
          countnum: "分数",
        },
      },
      timeValue: [],
      data: {},
      testName: "",
      listData: [],
      testId: "",
      stepData: [],
      active: false,
    };
  },
  methods: {
    switchRadio($typr, $exerciseId) {
      this.radio3 = 2;
      this.errorNumsDaingl = false;
      this.getData($typr);
      this.getStudentExamInfo($exerciseId, $typr);
    },
    errorNums($data) {
      this.errorNumsDaingl = true;
      this.errroeNumdata = $data;
    },
    clickCanvas($event, $data) {
      // debugger;
    },
    pageSizeChange() {},
    pageChange() {},
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getData($typr) {
      this.data = [];
      this.stepData = [];
      let data2 = {
        examinationId: this.$route.query.plan,
        relationId: this.$route.query.relationId,
        classId: this.$route.query.classId,
      };
      getclassexaminfo(data2).then((res) => {
        this.chartData.rows = [];
        if (res.code == 200 || res.code == 0) {
          this.pageDaa = res.data;
          this.pageDaa.sub_num = res.data.finishedNum;
          this.pageDaa.student_num = res.data.studentNum;
          res.data.userScore.forEach(
            function (index, i) {
              if (index.userId == $typr) {
                index.active = true;
              } else {
                index.active = false;
              }
              let obj = {
                counttime: index.studentName,
                countnum: index.score,
              };
              this.chartData.rows.push(obj);
            }.bind(this)
          );
          this.listData = res.data.userScore;
          if ($typr) {
            this.testId = $typr;
          } else {
            this.testId = res.data.userScore[0].userId;
            res.data.userScore[0].active = true;
          }

          if (this.radio3 == 1) {
            let _height = 0;

            let that = this;
            if (res.data.examCount) {
              res.data.examCount.forEach(function (index, i) {
                _height = 0;
                let _len = index.itemStep.length;
                index.itemStep.forEach(function (index, i) {
                  index.stepHeight = 50;
                  _height += index.stepHeight + 0.5;
                });
                index.nameHeight = _height;
              });
              this.data = res.data.examCount;
            }
            if (this.data.name) {
              this.testName = this.data.name;
            }
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 获取单个学生的实验点评
    getStudentExamInfo($id, $userId) {
      this.data = [];
      let data = {
        exercise_id: $id,
        user_id: $userId,
      };
      getstudentexaminfo1(data).then((res) => {
        let _height = 0;
        let that = this;
        if (res.data.steps) {
          res.data.steps.forEach(function (index, i) {
            _height = 0;
            let _len = index.itemStep.length;
            index.itemStep.forEach(function (index, i) {
              index.stepHeight = 50;
              _height += index.stepHeight + 0.5;

              if (index.comments) {
                index.comments.forEach(function (index, i) {
                  if (index != "+") {
                    that.stepData.push(index);
                  }
                });
              }
            });
            index.nameHeight = _height;
          });
          this.data.commentsList = res.data.comments;
          this.data.stepList = res.data.steps;
        }
        if (this.data.name) {
          this.testName = this.data.name;
        }
      });
    },
    first() {
      this.getData(this.listData[0].userId);
      this.getStudentExamInfo(
        this.listData[0].exerciseId,
        this.listData[0].userId
      );
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.testTip {
  background-color: #fff;
  color: #d8d8d8;
  padding: 0;
  border: 1px solid #d8d8d8;
}
</style>


// WEBPACK FOOTER //
// src/assets/js/pages/exam/TestDetails.vue